<div class="modal-header">
    <h3 *ngIf="mode === 'add'" class="modal-title" id="modal-title-id">{{LOCALIZATION.albumAddItem}}</h3>
    <h3 *ngIf="mode === 'remove'" class="modal-title" id="modal-title-id">{{LOCALIZATION.albumRemovePage}}</h3>
</div>
<div class="modal-body">
	<!-- // Add to Album -->
    <div *ngIf="mode == 'add'">
        <div class="well product-album-list" *ngIf="productAlbums && productAlbums.length>0 && !albumcreate">
            <div class="panel panel-default">
                <div class="panel-heading">{{LOCALIZATION.albumIncluded}}</div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-xs-12">
                            <ul style="padding-left:16px;">
                                <li *ngFor="let productAlbum of productAlbums">{{productAlbum.name}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="pointMe" (click)="albumcreate = true">
            <div class="row row-item">
                <div class="col-xs-4 text-center text-primary">
                    <i class="fas fa-plus-circle fa-2x"></i>
                </div>
                <div class="col-xs-8"><span>{{LOCALIZATION.albumNew}}</span></div>
            </div>
        </div>
        <div class="album-list-container">
            <div class="item-hover pointMe" 
                 [ngClass]="{'item-selected' : currentAlbum == i}"
            	 [hidden]="albumcreate"  
            	 *ngFor="let album of albums; let i = index;"
                 (click)="selectAlbum(i)">
                <div class="row row-item">
                    <div class="col-xs-4">
                    	<img style="max-width:50px;max-height:50px;border: 1px solid #eee;"
							 [src]="'/aw-server/rest/album/thumbnail/' + album[0]"
							 (error)="onImageError($event)"                    	
                             onerror="this.src='/app/aw-ui-angular/assets/img/noimage.webp'"
                             alt="Thumbnail for album with id {{album[0]}}">
                    </div>
                    <div class="col-xs-8"><span><em>{{album[1]}}</em></span></div>
                </div>
            </div>
        </div>
        <div *ngIf="!albumcreate">
            <label for="pagename" style="display:block">{{LOCALIZATION.pageNamePrompt}}</label>
            <input type="text" [(ngModel)]='input.pagename' id="pagename" class="form-control"
                   placeholder="{{LOCALIZATION.page}} {{LOCALIZATION.name}}" autofocus>
        </div>
        <div *ngIf="albumcreate">
            <input maxlength="255" type="text" [(ngModel)]='input.albumname' id="albumname" class="form-control"
                   placeholder="{{LOCALIZATION.album}} {{LOCALIZATION.name}}" required autofocus
                   (keyup)="onKeyup($event)" aria-label="New album name"/>
            <span *ngIf="!input.albumname.length" class="help-block pull-right">0/{{limits.albumname}}</span>
            <span *ngIf="input.albumname.length" class="help-block pull-right">{{input.albumname.length||0}}/{{limits.albumname}}</span>
        </div>
    </div>
    <!-- // END Add to Album -->
    <!-- // Remove from Album -->
    <div *ngIf="mode == 'remove'">
        <div class="well product-album-list" *ngIf="productAlbums && productAlbums.length>0">
            <div class="panel panel-default">
                <div class="panel-heading">Select the album you want to remove the document(s) from.</div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-xs-12">
							<ul class="list-unstyled" role="radiogroup" aria-labelledby="albumListLabel">
							    <li *ngFor="let productAlbum of productAlbums">
							        <label>
							            <input type="radio" 
							                   [(ngModel)]="selectedAlbum" 
							                   [value]="productAlbum"
							                   [attr.aria-label]="productAlbum.name"
							                   class="col-xs-1">
										<img class="col-xs-5 img-thumbnail" style="border: none;"
											   [src]="productAlbum._thumbs"
											   (error)="onImageError($event)"                                                
                                               alt="Thumbnail for album with id {{productAlbum.id}}">							                   
							            <span class="col-xs-6"><em>{{productAlbum.name}}</em></span>
							        </label>
							    </li>
							</ul>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
        <div *ngIf="!productAlbums || productAlbums.length==0">{{LOCALIZATION.albumsNotFound}}</div> 
    </div>    
    <!-- // END Remove from Album -->    
</div>
<div class="add modal-footer">
    <button class="btn btn-default" type="button" (click)="handleCloseClick()">{{ albumcreate ? LOCALIZATION.cancel : LOCALIZATION.close}}</button>
    <button *ngIf="mode == 'add'" class="btn btn-primary" type="button" (click)="handleAddClick()" [disabled]="inprogress">
        <i class="fas fa-spinner fa-spin fa-fw" [hidden]="!inprogress"></i>
        {{LOCALIZATION.add}}
    </button>
    <button *ngIf="mode == 'remove'" class="btn btn-danger" type="button" (click)="handleRemoveClick()" [disabled]="inprogress">
        <i class="fas fa-spinner fa-spin fa-fw" [hidden]="!inprogress"></i>
        {{LOCALIZATION.remove}}
    </button>    
</div>